import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/manga";

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-[4/5] w-full overflow-hidden bg-background-200">
        <img
          src={comic.cover}
          alt={`${comic.title} 漫画封面`}
          title={`${comic.title} 在线漫画`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-background-950/70 px-2 py-0.5 text-xs font-medium text-background-50">
          {comic.status}
        </span>
        <span className="absolute bottom-2 right-2 flex items-center gap-1 rounded-md bg-background-950/70 px-2 py-0.5 text-xs text-background-50">
          <i className="ri-star-fill text-accent-500" aria-hidden="true" />
          {comic.rating}
        </span>
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-bold text-foreground-950 group-hover:text-primary-600">
          {comic.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">{comic.latestChapter}</p>
        <div className="mt-2 flex items-center justify-between text-xs text-foreground-500">
          <span>{comic.categoryName}</span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" aria-hidden="true" />
            {comic.views}
          </span>
        </div>
      </div>
    </Link>
  );
}